import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Editor } from "primereact/editor";
import { ColorPicker } from "primereact/colorpicker";
import { transitionLengthOptions } from "../../../../../../utils/constants";

const transitionBgGroupColors = [
  "#FF8B00",
  "#E81123",
  "#CF3438",
  "#C40052",
  "#C00077",
  "#9B008A",
  "#871797",
  "#744DA8",
  "#10883E",
  "#0F7C0F",
  "#018675",
  "#2D7C9A",
  "#0063B1",
  "#6B69D6",
  "#8E8BD8",
  "#8764B8",
  "#038288",
  "#496860",
  "#525E54",
  "#7E735F",
  "#4B4A48",
  "#505C6A",
  "#4B5459",
  "#000000",
];

const AddTransitionSlideModel = ({
  isAddTransitionSlideModelVisible,
  setIsAddTransitionSlideModelVisible,
}) => {
  const [selectedTransitionValue, setSelectedTransitionValue] = useState(null);
  const [transitionText, setTransitionText] = useState("");
  const [selectedBgColor, setSelectedBgColor] = useState(null);
  const [isSelectedCustomColor, setIsSelectedCustomColor] = useState(false);
  const [customBgColor, setCustomBgColor] = useState("#e0e0e0");
  const playerRef = useRef(null);
  const uploadPhotoRef = useRef(null);

  return (
    <Dialog
      header={"Add Transition Slide"}
      position={"top"}
      visible={isAddTransitionSlideModelVisible}
      style={{ width: "50vw" }}
      onHide={() => {
        if (!isAddTransitionSlideModelVisible) return;
        setIsAddTransitionSlideModelVisible(false);
      }}
      blockScroll
    >
      <div className="my-3 d-flex flex-column justify-content-center align-items-center my-4">
        <div className="col-md-8 col-12">
          <div className="upload label fs-14 mb-2">
            Select a Background Image:
          </div>
          <div className="d-flex align-items-center">
            <InputText
              id="task_name"
              ref={uploadPhotoRef}
              type="file"
              className={`m-color -100 inputField`}
              placeholder=""
              onChange={(e) => {
                console.log(e.target.files[0]);
              }}
            />
            <Button
              className="add-question-btn createClientBtn d-flex justify-content-center"
              style={{
                padding: "12px 24px",
                borderRadius: "unset",
              }}
              onClick={() => uploadPhotoRef.current.click()}
            >
              Browse
            </Button>
          </div>
        </div>
      </div>

      <div className="text-center fs-16">OR</div>

      <div className="d-flex flex-column my-4">
        <label className="mb-1 text-start" style={{ color: "#666666" }}>
          Select a Background Color:
        </label>
        <div className="d-flex flex-wrap gap-1 align-items-center mb-3 color-groups">
          {transitionBgGroupColors.map((color) => (
            <button
              key={color}
              style={{
                backgroundColor: color,
                border:
                  selectedBgColor === color
                    ? "3px solid #2196F3"
                    : `1px solid ${color}`,
              }}
              onClick={() => {
                setSelectedBgColor(color);
                setIsSelectedCustomColor(false);
              }}
              title={color}
              className="p-0 cusrsor-pointer color-group"
            />
          ))}
          <button
            style={{
              border: "1px solid #f0f0f0",
              border: isSelectedCustomColor
                ? "3px solid #2196F3"
                : `1px solid #f0f0f0`,
              fontSize: "18px",
              backgroundColor: "#f0f0f0",
            }}
            title="Custom color"
            onClick={() => {
              setIsSelectedCustomColor(true);
              setSelectedBgColor(null);
            }}
            className="p-0 cusrsor-pointer d-flex align-items-center justify-content-center color-group"
          >
            +
          </button>
        </div>
        {isSelectedCustomColor && (
          <div className="d-flex align-items-center gap-2">
            <label
              className="mb-0"
              style={{ color: "#666666", fontSize: "14px" }}
            >
              Custom Color:
            </label>
            <div className="colorpicker d-flex align-items-center">
              <InputText
                autoFocus
                value={customBgColor}
                name="custom-bg-color"
                onChange={(e) => setCustomBgColor(customBgColor)}
                placeholder="Enter Background Color"
                readOnly
                className="cusotm-color-input w-75"
              />
              <div className="color-picker-box d-flex align-items-center justify-content-center p-2">
                <ColorPicker
                  value={customBgColor}
                  onChange={(e) => setCustomBgColor(e.value)}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="d-flex flex-column my-4">
        <label className="mb-1 text-start" style={{ color: "#666666" }}>
          Transition Text (Optional):
        </label>
        <div className="d-flex align-items-center m-color -100">
          <Editor
            className={`inputField fs-14 m-color -100`}
            value={transitionText}
            onTextChange={(e) => {
              setTransitionText(e.htmlValue);
            }}
            style={{
              height: "120px",
              textAlign: "left",
            }}
          />
        </div>
      </div>

      <div className="row my-4">
        <div className="col-md-4">
          <label className="form-label mb-1 fs-14">
            Transition Length (In Seconds):
          </label>
          <Dropdown
            value={selectedTransitionValue}
            onChange={(e) => {
              setSelectedTransitionValue(e.value);
            }}
            options={transitionLengthOptions}
            optionLabel="name"
            placeholder="Select transition length"
            className="m-color w-100 inputField"
          />
        </div>
      </div>
      {/* BUTTONS */}
      <div className="d-flex justify-content-center gap-2 mt-4">
        <Button
          label="Cancel"
          className="px-4 py-2 fw-bold cancel"
          onClick={() => {
            if (!isAddTransitionSlideModelVisible) return;
            setIsAddTransitionSlideModelVisible(false);
          }}
        />

        <Button
          label="Save"
          className="px-4 py-2 fw-bold createClientBtn d-flex align-items-center"
          onClick={() => {
            console.log("Save Transition Slide");
            if (!isAddTransitionSlideModelVisible) return;
            setIsAddTransitionSlideModelVisible(false);
          }}
        />
      </div>
    </Dialog>
  );
};

export default AddTransitionSlideModel;
